const HELP_TEXTS = {
  actionButtons: {
    exportCampaigns:
      'An exhaustive export of this list will be sent to you shortly by Email. It can take a few minutes for the Email to be sent.',
    handover: 'Select one or multiple Campaigns to handover',
  },
  info: {
    openBudget: 'Spendable Budget minus Spent Budget',
    openChangeRequests: 'Number of Open Change Requests',
    securedBudget:
      'Sum of all spendable budget for Campaigns that are part of Agreed Opportunities',
    securedPushedBudget:
      'Sum of all spendable budgets for Campaigns that are Pushed or Locked and part of Agreed Opportunities',
    netClientBudget:
      'The sum of the NetClientBudgetExternal and WKZBudget that BI will use',
    netClientBudgetExternal:
      'The part of NetClientBudget that will be invoiced to the clients',
    wkzBudget:
      'The part of NetClientBudget that will be invoiced to the WKZ cost center',
    coInvest:
      'Co-Invest is the amount of budget that is invested by Zalando (Category Management, Markets, Marketing). This amount needs to be invoiced to Zalando',
    freeService: 'The free service',
    spendableBudget:
      'The total spendable budget, calculated from NetClientBudget, HeaderDiscount, CoInvest, AdjustedFee and FreeService',
  },
  listHeaders: {
    pendingChangeRequestsCount: 'Number of PENDING Campaign Change Requests',
  },
  changeRequest: {
    upsell:
      'An upsell budget doesn`t impact the revenues reported in the past, only impacts the revenue going forward.',
  },
};

export default HELP_TEXTS;
